export function getEnv<T>(name: string): T | null {
  const tag = document.querySelector(`meta[name=${name}]`);

  if (tag) {
    return tag.getAttribute('content') as T;
  }

  return null;
}
